import * as dateFns from "date-fns";

export function adjustDateByDayCount(date: Date, days: number): Date {
    return new Date(date.getTime() + days * (24 * 60 * 60 * 1000));
}

export function getDaysAgo(daysAgo: number): Date {
    return adjustDateByDayCount(new Date(), -1 * daysAgo);
}

export function formatDateForServiceStack(date: Date): string {
    // note this converts to UTC before serialising
    return date.toISOString();
}

export function getDefaultDateRange(requestedDate?: Date): [Date, Date] {
    if (requestedDate) {
        return [requestedDate, new Date(dateFns.addHours(requestedDate, 2))];
    }

    return [dateFns.subHours(new Date(), 2), new Date()];
}

export function formatDate(date: Date, timeZoneId: string): string {
    const dateFormat = Intl.DateTimeFormat('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric', hour12: true, timeZone: timeZoneId });
    return dateFormat.format(date);
}

export function formatShortTime(date: Date, timeZoneId: string): string {
    // intervening on standard Intl.DateTimeFormat to remove unnecessary space and uppercase AM/PM
    const timeFormat = Intl.DateTimeFormat('en-AU', { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: timeZoneId });
    return (timeFormat.format(date)).replace(/ (pm|am)$/, '$1').toUpperCase();
}

export function formatDateAndTime(date: Date, timeZoneId: string): string {
    // intervening on standard Intl.DateTimeFormat to remove comma
    return `${formatDate(date, timeZoneId)} ${formatShortTime(date, timeZoneId)}`;
}

export function isSameDay(date1: Date, date2: Date, timeZoneId: string): boolean {
    // this is stupid but date-fns doesn't support time zones and upgrading date-fns required additional work
    return formatDate(date1, timeZoneId) === formatDate(date2, timeZoneId);
}
